module.exports = __webpack_public_path__ + "img/localizations.dea8a115.svg";